module.exports = __webpack_public_path__ + "static/img/home_workbench.6e54bc6d.svg";